import React from 'react'
import { MainLayout } from '../styles/Layouts'
import Title from '../Components/Title';
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { MdOutlineKeyboardArrowRight } from 'react-icons/md'
import Uangku from '../Components/Uangku';

const UangkuPage = () => {
    return (
        <>
        <title>Uangku | Foxicode</title>
        <MainLayout>
            <MuzeStyle>
                <Title title={'Uangku'} span={'私のお金'} />
                <TitleM><Link to="works"><span>Works</span></Link><Arrow/> Uangku - App</TitleM>
                <Uangku />
            </MuzeStyle>
        </MainLayout>
        </>
    )
}

const Arrow = styled(MdOutlineKeyboardArrowRight)`
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: var(--font-light-color);
    @media screen and (max-width: 768px){
        font-size: 36px;
    }
`

const MuzeStyle = styled.section`
`
const TitleM = styled.h1`
    text-align: left;
    display : flex;
    font-size: 40px;
    color: var(--font-light-color);
    margin-top: 4rem;
    @media screen and (max-width: 768px){
        font-size: 25px;
        padding: 0 1rem;
    }

    Span{
        text-align: left;
        font-size: 40px;
        color: #c46500;
        @media screen and (max-width: 768px){
        font-size: 25px;
    }
    }
`
export default UangkuPage

